<div
  class="backdrop"
  [style.opacity]="backdropOpacity"
  [style.pointer-events]="backdropPointerEvents"
  (click)="closeOnBackdropClick()"
></div>

<div
  class="sheet-container"
  [style.transform]="dragTransform || sheetTransform"
  [style.transition]="isDragging ? 'none' : sheetTransition"
>
  <div
    class="dragger-container"
    (pointerdown)="onDragStart($event)"
    (touchstart)="onDragStart($event)"
    (click)="$event.stopPropagation()"
  >
    <div class="dragger"></div>
  </div>

  <div class="peek-content" [style.opacity]="miniOpacity">
    <div class="peek-header">
      <div class="title-wrap" (click)="expand()">
        <h4 class="peek-title" title="{{ restStop.name }}">{{ restStop.name }}</h4>
        <div class="rating-chip">
          <mat-icon>star</mat-icon>
          <span>{{ restStop.averageRating | number: '1.1-1' }}</span>
        </div>
      </div>
      <div class="actions-group">
        <a
          [href]="mapsHref"
          [attr.target]="isMobile ? null : '_blank'"
          [attr.rel]="isMobile ? null : 'noopener noreferrer'"
        >
          <button mat-icon-button aria-label="Route berechnen">
            <mat-icon>directions_walk</mat-icon>
          </button>
        </a>
        <button
          mat-icon-button
          aria-label="Zu Favoriten hinzufügen"
          color="accent"
          (click)="favoritesService.toggleFavorite(restStop.id)"
        >
          <mat-icon>{{ (isFavorite$ | async) ? 'favorite' : 'favorite_border' }}</mat-icon>
        </button>
        <button mat-icon-button (click)="requestClose()" aria-label="Schließen">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="peek-icons" (click)="expand()">
      <mat-icon *ngFor="let feature of allAvailableFeatures">{{ feature.icon }}</mat-icon>
    </div>
  </div>

  <div
    class="expanded-content"
    #expandedContent
    [style.opacity]="expandedOpacity"
    [attr.aria-hidden]="currentState === 'expanded' ? 'false' : 'true'"
  >
    <div class="scrollable-content">
      <header class="expanded-header">
        <h3>{{ restStop.name }}</h3>
        <div class="actions-group">
          <a
            [href]="mapsHref"
            [attr.target]="isMobile ? null : '_blank'"
            [attr.rel]="isMobile ? null : 'noopener noreferrer'"
          >
            <button mat-icon-button aria-label="Route berechnen">
              <mat-icon>directions_walk</mat-icon>
            </button>
          </a>
          <button
            mat-icon-button
            aria-label="Zu Favoriten hinzufügen"
            color="accent"
            (click)="favoritesService.toggleFavorite(restStop.id)"
          >
            <mat-icon>{{ (isFavorite$ | async) ? 'favorite' : 'favorite_border' }}</mat-icon>
          </button>
          <button mat-icon-button (click)="requestClose()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </header>
      <section class="rating-summary-section">
        <div class="left">
          <span class="rating-value">{{ restStop.averageRating | number: '1.1-1' }}</span>
          <div class="stars">
            <mat-icon *ngFor="let starType of getStarRatingArray(restStop.averageRating)">{{ starType }}</mat-icon>
          </div>
        </div>
        <div class="right">
          <span class="review-count">{{ restStop.reviewCount }} Bewertungen</span>
        </div>
      </section>
      <mat-divider></mat-divider>
      <app-rest-stop-photos [data]="restStop"></app-rest-stop-photos>
      <mat-divider></mat-divider>
      <div class="manual-tabs-header">
        <button [class.active]="activeTabIndex === 0" (click)="activeTabIndex = 0; loadReviews()" class="tab-button">
          Bewertungen
        </button>
        <button [class.active]="activeTabIndex === 1" (click)="activeTabIndex = 1" class="tab-button">
          Ausstattung
        </button>
      </div>

      <div class="tab-body-container">
        <div [class.hidden]="activeTabIndex !== 0" class="tab-body">
          <app-review-section
            [restStopId]="restStop.id"
            [restStop]="restStop"
            [showHeader]="false"
          ></app-review-section>
        </div>
        <div [class.hidden]="activeTabIndex !== 1" class="tab-body">
          <section class="features-section">
            <div class="features-grid">
              <div class="feature-item" *ngFor="let feature of allAvailableFeatures">
                <mat-icon>{{ feature.icon }}</mat-icon>
                <span>{{ feature.label }}</span>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
